import {
  getCurrencyDecimals,
  roundToCurrencyPrecision,
} from './currency-formatter';

/**
 * Ensure an amount has the correct number of decimal places for display
 * This prevents floating point issues like 10.499999999999998
 */
export function cleanAmount(amount: number, currencyCode: string): number {
  const decimals = getCurrencyDecimals(currencyCode);
  return parseFloat(amount.toFixed(decimals));
}

/** Rounds to the currency's precision first, then scales, so 0.1 + 0.2 EUR is 30 minor units, never 30.000000000000004. */
export function toMinorUnits(amount: number, currency: string): number {
  return Math.round(
    roundToCurrencyPrecision(amount, currency) *
      10 ** getCurrencyDecimals(currency)
  );
}

export function fromMinorUnits(minor: number, currency: string): number {
  return roundToCurrencyPrecision(
    minor / 10 ** getCurrencyDecimals(currency),
    currency
  );
}

export function sumMinorUnits(
  amounts: readonly number[],
  currency: string
): number {
  return amounts.reduce(
    (sum, amount) => sum + toMinorUnits(amount, currency),
    0
  );
}
